import { render, staticRenderFns } from "./CiteScore.vue?vue&type=template&id=85f1c8aa&scoped=true"
import script from "./CiteScore.vue?vue&type=script&lang=js"
export * from "./CiteScore.vue?vue&type=script&lang=js"
import style0 from "./CiteScore.vue?vue&type=style&index=0&id=85f1c8aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f1c8aa",
  null
  
)

export default component.exports